module.exports = {
      id: "politics-usage",
      viewBox: "0 0 93.75 88.955",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#politics",
      toString: function () {
        return this.url;
      }
    }